export default {
  CARD_START: 'Start',
  CARD_LOCKED: 'Låst',
  CARD_DONE: 'Repeter',
  CARD_IN_PROGRESS: 'Fortsette',
  CARD_DONE_LINK: 'Se oppgavene',
  CARD_ITEMS_FINISHED: 'steder fullført',
}
